<template>
  <div :class="wrapperClass">
    <div
      v-if="kyc_brand"
      class="top"
      :class="{ 'dis_none': $route.path !== '/user/KYC' && $route.path !== '/user/edit' && $route.path !== '/user/verify' }"
    >
      {{ $t('Bao.personal_info_setting') }}
    </div>
    <div :class="{ 'kyc-frame': kyc_page }">
      <ul
        class="kyc-tab-frame"
        :class="{ 'dis_none': kyc_brand || $route.path !== '/user/KYC' && $route.path !== '/user/edit' && $route.path !== '/user/verify' }"
      >
        <li
          class="tab-items verify-items "
          :class="{ 'active': $route.path === '/user/edit' }"
          @click="$router.push('/user/edit')"
        >
          {{ $t('Bao.personal_info_setting') }}
        </li>
        <li
          v-if="!isThemePurple"
          class="tab-items kyc-items"
          :class="{ 'active': $route.path === '/user/KYC' }"
          @click="$router.push('/user/KYC')"
        >
          {{ $t('Bao.personal_info_kyc') }}
        </li>
        <li
          v-if="permissionInfo.enable_google_totp"
          class="tab-items authenticator-items"
          :class="{ 'active': $route.path === '/user/verify' }"
          @click="$router.push('/user/verify')"
        >
          {{ $t("Bao.auth_page_text_1") }}
        </li>
      </ul>
      <ul
        v-if="!kyc_page"
        class="nav-tabs "
      >
        <li :class="{ 'active': $route.path === '/user' }" @click="$router.push('/user')">
          <span>
            {{ $t("Bao.personal") }}
          </span>
        </li>
        <li :class="transactionClass" @click="$router.push('/user/transaction-history')">
          <span>
            {{ $t("Bao.transaction-index") }}
          </span>
        </li>
        <li

          :class="{ active: $route.path === '/user/bank' || $route.path === '/user/bank/create' }"
          @click="$router.push('/user/bank')"
        >
          <span>{{ $t("Bao.add_bank_card") }}</span>
        </li>
        <li

          :class="{ 'active': $route.path === '/user/letter' }"
          @click="$router.push('/user/letter')"
        >
          <span>
            {{ $t("Bao.announcement_letter") }}
          </span>
        </li>
        <li
          v-if="!isThemePurple"
          :class="{ 'active': $route.path.startsWith('/user/news') }"
          @click="$router.push('/user/news')"
        >
          <span>
            {{ $t("Bao.news") }}
          </span>
        </li>
        <!-- <li
          v-show="token && memberInfo.member_type !== 3"
          :class="{ 'active': $route.path === '/user/friend' }"
          @click="$router.push('/user/friend')"
        >
          <span>
            {{ $t("Bao.promos") }}
          </span>
        </li> -->
      </ul>
      <router-view :class="{ 'kyc-container': kyc_page }" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['token', 'brandInfo', 'memberInfo', 'permissionInfo', 'currentTheme']),
    route() {
      return this.$route
    },
    kyc_brand() {
      return this.brandInfo.kyc_brand !== 'self'
    },
    kyc_page() {
      return this.route.path === '/user/edit' || this.route.path === '/user/KYC' || this.route.path === '/user/verify'
    },
    wrapperClass() {
      if (this.route.path === '/user/edit' && this.kyc_brand) {
        return 'my-wrap-kyc'
      } else if (this.route.path === '/user') {
        return 'my-wrap'
      } else if (this.route.path !== '/user/edit' && !this.kyc_page) {
        return 'my-wrap finance-wrap'
      } else {
        return 'my-wrap my-kyc-wrap'
      }
    },
    transactionClass() {
      return {
        'active': this.route.path === '/user/transaction-history' ||
                  this.route.path === '/user/bonus' ||
                  this.route.path === '/user/commission' ||
                  this.route.path === '/user/deposit-record' ||
                  this.route.path === '/user/withdrawal-record'
      }
    },
    isThemePurple() {
      return this.currentTheme === 'theme_purple'
    }
  },
  created() {
  }
}
</script>
